import type { RiotId, ValorantRegion } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { cn } from '@/shared/utils/cn';

export interface ProfileDetailsGameplayNametagProps extends HTMLAttributes<HTMLDivElement> {
  riotId?: RiotId;
  region: ValorantRegion;
}

export const ProfileDetailsGameplayNametag = memo(
  function ProfileDetailsGameplayNametag(
    props: ProfileDetailsGameplayNametagProps,
  ) {
    const { riotId, region, className, ...rest } = props;

    const displayName = riotId
      ? `${riotId.gameName}#${riotId.tagLine}`
      : 'Unknown';

    return (
      <div {...rest} className={cn('flex items-center gap-2', className)}>
        <p className="text-cold-300 truncate text-xs leading-none font-light">
          {displayName}
        </p>
        <span className="text-cold-300 text-sm font-bold">{region}</span>
      </div>
    );
  },
);
